module.exports = __webpack_public_path__ + "static/media/dashboard_icon_yellow.f957e07f.svg";